var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"nav d-flex align-center pt-5 pb-2",class:_vm.navBg},[_c('div',{staticClass:"container d-flex justify-space-between align-center"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }